// extracted by mini-css-extract-plugin
export default {"testBox":"ayIrCAN4vogpYPXu7Fgh","cardHeader":"N1Zevav1JOKohyG1pIl5","cardFooter":"YAb9egzJvJ9bimREcvDD","addTestResultBtn":"EePHU8BiF3kzYincZTSR"};